import React from "react";
import Gear from "../../assets/gear.png";
import Header from "../../components/Header";
import {
  Row,
  Col,
  Avatar,
  Typography,
  Card,
  Divider,
  Space,
  Tooltip,
} from "antd";
import {
  FieldTimeOutlined,
  InstagramFilled,
  TwitterCircleFilled,
  WhatsAppOutlined,
  LinkedinFilled,
  GithubFilled,
  YoutubeOutlined,
} from "@ant-design/icons";
import FormContact from "./FormContact";
import MyProfile from "../../assets/93118142_2536241006686260_3992929020898443264_n.jpg";
const Contact = ({ isBreakPosition }) => {
  return (
    <div style={{ margin: "24px" }}>
      <Header
        width={isBreakPosition ? 16 : 8}
        title="Contact Me"
        desciption="Get in touch with me"
        withDesc
      />
      <img
        alt="gear-background"
        style={{ right: 0, position: "absolute" }}
        src={Gear}
      />
      <Row>
        <Col span={isBreakPosition ? 24 : 12} style={{ marginTop: "8vmin" }}>
          <Typography.Paragraph>
            <Avatar
              style={{ float: "left", margin: 12 }}
              size={100}
              src={MyProfile}
            />
            I am a professional in programming. If you are interested in
            contacting me you can contact you via contact below. I'm open to
            connections as well as for new offers.
          </Typography.Paragraph>
          <Typography.Paragraph
            style={{ display: "flex", alignItems: "center" }}
          >
            <FieldTimeOutlined
              style={{ color: "#E3872D", fontSize: "32px", marginRight: 10 }}
            />
            All-time available for your offer
          </Typography.Paragraph>
          <Divider>Find me in other media</Divider>
          <Space size={52} align="center">
            <Tooltip title="@brilliano_d" placement="right">
              <a href="https://www.instagram.com/brilliano_d/">
                <InstagramFilled
                  style={{ color: "#403D3C", fontSize: "32px" }}
                />
              </a>
            </Tooltip>
            <Tooltip title="@kanrisha_li" placement="right">
              <a href="https://www.youtube.com/@kanrisha_li">
                <YoutubeOutlined
                  style={{ color: "#403D3C", fontSize: "32px" }}
                />
              </a>
            </Tooltip>
            <Tooltip title="+85 155 436 866" placement="right">
              <a href="https://www.whatsapp.com/">
                <WhatsAppOutlined
                  style={{ color: "#403D3C", fontSize: "32px" }}
                />
              </a>
            </Tooltip>
            <Tooltip title="Brilliano Dhiya Ulhaq" placement="right">
              <a href="https://www.linkedin.com/in/brilliano-dhiya-ulhaq-44b196194/">
                <LinkedinFilled
                  style={{ color: "#403D3C", fontSize: "32px" }}
                />
              </a>
            </Tooltip>

            <Tooltip title="brillianodhiya" placement="right">
              <a href="https://github.com/brillianodhiya">
                <GithubFilled style={{ color: "#403D3C", fontSize: "32px" }} />
              </a>
            </Tooltip>
          </Space>
        </Col>
        <Col
          span={isBreakPosition ? 24 : 12}
          style={{
            padding: !isBreakPosition ? 16 : 0,
            marginTop: isBreakPosition && "8vmin",
            // order: isBreakPosition ? 1 : 2,
          }}
        >
          <Card
            title="Contact Form"
            style={{
              padding: 16,
            }}
          >
            <FormContact />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Contact;
